// Basic query helper
const isPageOfType = (key: string): boolean => {
  const qs = typeof window !== 'undefined' ? window.location.search : '';
  const p = new URLSearchParams(qs);
  return p.has(key) || qs.includes(`${key}=`);
};

export const recalculate = (): boolean => {
  const qs = typeof window !== 'undefined' ? window.location.search : '';
  const params = new URLSearchParams(qs);

  const isArticleParam = params.has('a') || params.has('article');
  const isCategoryParam = params.has('ctgry');
  const isSearchParam = params.has('s');

  // Fallback checks to cover alternate code path
  // check this: seem unneeded
  const byUtil = isPageOfType('a') || isPageOfType('article') || isPageOfType('ctgry') || isPageOfType('s');

  // Heuristic: Gladly article injected in DOM
  const hasArticleDom = !!document.querySelector(
    '[data-ui="gladly-article"], .gladly-article, #gladly-article',
  );

   return !(isArticleParam || isCategoryParam || isSearchParam || byUtil || hasArticleDom);
};
